import { PLATFORM_CHROMEBOOK } from '../constants';

export const getDefaultProperties = () => {
  return {
    platform: PLATFORM_CHROMEBOOK,
  };
};
